import { getLocalStorageInfo } from "../../console_management/utils_v2"
import config from '../../config';

export const leaseStatus = {
    jacLeaseStatus: [{ label: 'Prospect', value: '11' }, { label: 'In Storage', value: '10' }, { label: 'Lease Return', value: '9' }, { label: 'MOU Signed', value: '8' }, { label: 'MOU Issued', value: '7' }, { label: 'Lease Issued', value: '6' }, { label: 'Archive', value: '5' }, { label: 'Written Off/ Sold / Part out', value: '4' },
    { label: 'Off Lease', value: '2' }, { label: 'On Lease', value: '1' },],
    defaultLeaseStatus: [{ label: 'Archive', value: '5' }, { label: 'On Lease', value: '1' }, { label: 'Off Lease', value: '2' }, { label: 'On Ground', value: '3' }, { label: 'Written Off/ Sold / Part out', value: '4' },],
    airAsiaLeaseStatus: [{ label: 'Prospect', value: '11' }]
}
export const revisionItemList = [
    { content_type: 'amaogandincidents', value: 'AOG and Incidents' },
    { content_type: 'amaircraft', value: 'Aircraft' },
    { content_type: 'amengine', value: 'Engine' },
    { content_type: 'amapu', value: 'APU' },
    { content_type: 'ampropeller', value: 'Propeller' },
    { content_type: 'amlandinggear', value: 'Landing Gear' },
    { content_type: 'amavionics', value: 'Avionics' },
    { content_type: 'amcrewseating', value: 'Crew Seat' },
    { content_type: 'amlavatory', value: 'Lavatory' },
    { content_type: 'ampassengerseating', value: 'Passenger Cabin' },
    { content_type: 'amgalley', value: 'Galley' },
    { content_type: 'amcabinequipments', value: 'Equipment' },
    { content_type: 'amlopahistory', value: 'LOPA' },
    { content_type: 'amstcmods', value: 'STCs & Mods' },
    { content_type: 'amremarks', value: 'Additional Remarks' },
]
export const revisionInItem = {
     'amaogandincidents': 'AOG and Incidents' ,
     'amaircraft': 'Aircraft' ,
     'amengine': 'Engine' ,
     'amapu': 'APU' ,
     'ampropeller': 'Propeller' ,
     'amlandinggear': 'Landing Gear' ,
     'amavionics': 'Avionics' ,
     'amcrewseating': 'Crew Seat' ,
     'amlavatory': 'Lavatory' ,
     'ampassengerseating': 'Passenger Cabin' ,
     'amgalley': 'Galley' ,
     'amcabinequipments': 'Equipment' ,
     'amlopahistory': 'LOPA' ,
     'amstcmods': 'STCs & Mods' ,
     'amremarks': 'Additional Remarks',
     'amutilization' : 'Custom Utilization',
     'amcomponent' : 'Component',
     'amenginelimitedlifepart' : 'Primary LLP',
     'amenginelimitedlifepartsecondary' : 'Secondary LLP',
     "amarchivedreports" : "Archived Tech Specs",
     'amassetnonllp' : 'Non LLP',
     "cdmanufacturers": "Manufacturers",
     "cdaircraftfamily": "Aircraft Family",
     "cdaircrafttype": "Aircraft Type",
     "cdaircrafttypemodel": "Aircraft Model",
     "cdenginefamilies": "Engine Family",
     "cdenginetypes": "Engine Type",
     "cdaputype": "APU Type",
     "cdlgsubassemblies": "LG Sub Assemblies",
     "cdregions": "Region",
     "cdmodule": "LLP Module",
     "cddescription": "LLP Description",
     "cdllp": "LLP",
     "cdsveventmaintenanceprograms": "SV Events",
     "cdstcandmod": "STC / MOD",
     "amowner": "Owner",
     "amlessordistributionemails": "Distribution Emails",
     "ambankdetails": "Bank Details",
     "amairlinescontact": "Airline Contacts",
     "amlesseeandoperatorsv2": "Lessee"
}

export const revisionFieldList = {
    "cdmanufacturers": ['name', 'address', 'remarks'],
    "cdaircraftfamily": ['name', 'manufacturer', 'ac_type', 'remarks'],
    "cdaircrafttype": ['name', 'aircraft_body_type', 'no_of_engines', 'no_of_landing_gears', 'aircraft_family', 'has_propeller', 'has_apu', 'remarks'],
    "cdaircrafttypemodel": ['name', 'ac_types', 'aircraft_type', 'remarks'],
    "cdenginefamilies": ['name', 'manufacturer', 'remarks',],
    "cdenginethrustcategory": ['name', 'remarks'],
    "cdenginetypes": ['name', 'engine_family', 'aircraft_body_type', 'aircraft_type', 'svc_escalation', 'svc_interval', 'low_escalation', 'low_interval', 'thrust', 'remarks'],
    "cdaputype": ['name', 'manufacturer', 'aircraft_type', 'remarks'],
    "cdlgsubassemblies": ['name', 'position', 'aircraft_type', 'remarks'],
    "cdregions": ['name', 'remarks'],
    "cddescription": ['module', 'name', 'llp_type', 'remarks'],
    "cdmodule": ['name'],
    "cdllp": ['module', 'description', 'part_number', 'is_hour_cycle', 'remarks', 'linked_engine'],
    "cdsveventmaintenanceprograms": ['name', 'category', 'asset_type', 'aircraft_type', 'engine_type', 'apu_type', 'is_llp_event', 'hours', 'cycles', 'months', 'days', 'escalation', 'year', 'cost', 'ground_time', 'show_in_ops', 'remarks'],
    "cdstcandmod": ['name', 'aircraft_types'],
    "amlessordistributionemails": ['lessee', 'emails'],
    "amowner": ['name', 'reference_name', 'address', 'contact', 'contact_phone_number', 'contact_fax', 'country_of_incorporation', 'jurisdiction', 'qb_company_id', 'legal_entity', 'display_name', 'cc_address', 'reply_to', 'vat_registration_number'],
    "ambankdetails": ['lessor', 'name', 'account_name', 'account_number', 'code', 'swift_code', 'hub_number', 'vat_number', 'iban', 'aba_number', 'sort_code', 'reference', 'note', 'footer_note', 'jurisdiction', 'spv', 'status', 'rejection_reason'],
    "amlesseeandoperatorsv2": ['name', 'country_of_incorporation', 'country_code', 'lessee', 'atten_to', 'contact_email', 'contact_phone_number', 'contact_fax_number', 'vat_registration_number', 'contact_address', 'logo', 'is_active'],
    "amairlinescontact": ['full_name', 'email', 'lessee', 'title', 'phone_number', 'fax']
}

export const revisionValueFormatter = {
    "ambankdetails": { status: (value) => String(value) === '1' ? 'Approved' : 'Disabled', },
    "amlesseeandoperatorsv2": { is_active: (value) => ['true', '1'].includes(String(value).toLowerCase()) ? 'Active' : 'Inactive', },
    "cddescription": { llp_type: (value) => ({ '1': 'Primary LLP', '2': 'Secondary LLP', '3': 'Both' })[String(value)] || value, },
}

export const getRevisionDisplayValue = (contentType, key, value) => {
    const formatter = revisionValueFormatter[contentType]?.[key];
    return formatter && value !== null && value !== undefined && value !== '' && value !== 'None' ? formatter(value) : null;
}

export const castleAirInstance = [479,472].includes(getLocalStorageInfo()?.defaultLessor?.id);
export const halcyonInstance = [484].includes(getLocalStorageInfo()?.defaultLessor?.id);
export const jetStreamInstance =  [442,463].includes(getLocalStorageInfo()?.defaultLessor?.id);
export const smbcInstance = [465].includes(getLocalStorageInfo()?.defaultLessor?.id);
export const lessorCheckInstance =  [406].includes(getLocalStorageInfo()?.defaultLessor?.id) ;
export const titanAviInstance =  getLocalStorageInfo()?.defaultLessor?.id === 480;
export const gaTelesisInstance = [498].includes(getLocalStorageInfo()?.defaultLessor?.id);
export const hanwahaInstance = [483].includes(getLocalStorageInfo()?.defaultLessor?.id);
export const avationPlcInstance =  [504].includes(getLocalStorageInfo()?.defaultLessor?.id);
export const leshaBankInstance = [510].includes(getLocalStorageInfo()?.defaultLessor?.id);
export const regionalOneInstance = [242].includes(getLocalStorageInfo()?.defaultLessor?.id);
export const mtInstance = [519].includes(getLocalStorageInfo()?.defaultLessor?.id);
export const wngCapitalInstance =  getLocalStorageInfo()?.defaultLessor?.id === 213;
export const testLessor = getLocalStorageInfo()?.defaultLessor?.id === 13;
export const acuCamoInstance = getLocalStorageInfo()?.defaultLessor?.id === 409;
export const spartaLease = getLocalStorageInfo()?.defaultLessor?.id === 321;